import * as angular from "angular";

export class FeatureService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/feature";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.id, data);
    }
}

angular.module("vcServices").service("FeatureService", FeatureService);
